var map = {
	"./ar/easy/text.json": "./src/locale/ar/easy/text.json",
	"./cs/easy/text.json": "./src/locale/cs/easy/text.json",
	"./cy/easy/text.json": "./src/locale/cy/easy/text.json",
	"./da/easy/text.json": "./src/locale/da/easy/text.json",
	"./de/easy/text.json": "./src/locale/de/easy/text.json",
	"./en/easy/text.json": "./src/locale/en/easy/text.json",
	"./es/easy/text.json": "./src/locale/es/easy/text.json",
	"./fi/easy/text.json": "./src/locale/fi/easy/text.json",
	"./fr/easy/text.json": "./src/locale/fr/easy/text.json",
	"./he/easy/text.json": "./src/locale/he/easy/text.json",
	"./hr/easy/text.json": "./src/locale/hr/easy/text.json",
	"./hu/easy/text.json": "./src/locale/hu/easy/text.json",
	"./it/easy/text.json": "./src/locale/it/easy/text.json",
	"./ja/easy/text.json": "./src/locale/ja/easy/text.json",
	"./kk/easy/text.json": "./src/locale/kk/easy/text.json",
	"./ko/easy/text.json": "./src/locale/ko/easy/text.json",
	"./nl/easy/text.json": "./src/locale/nl/easy/text.json",
	"./pl/easy/text.json": "./src/locale/pl/easy/text.json",
	"./pt/easy/text.json": "./src/locale/pt/easy/text.json",
	"./ro/easy/text.json": "./src/locale/ro/easy/text.json",
	"./ru/easy/text.json": "./src/locale/ru/easy/text.json",
	"./sh/easy/text.json": "./src/locale/sh/easy/text.json",
	"./sk/easy/text.json": "./src/locale/sk/easy/text.json",
	"./sr/easy/text.json": "./src/locale/sr/easy/text.json",
	"./sv/easy/text.json": "./src/locale/sv/easy/text.json",
	"./vi/easy/text.json": "./src/locale/vi/easy/text.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/easy\\/text\\.json$";